import { default as Login } from "./LoginPage";

export default Login;
